import React from "react";

export default function Careers() {
  return (
    <section className="page-container">
      <h2>Careers</h2>
      <p>We’re hiring! Email your resume to support@berkinson.com.</p>
    </section>
  );
}
